<div class="wireless-map" [class.public]="isPublic">
    <div id="map" class="map" leaflet [leafletOptions]="mapOptions" (leafletMapReady)="onMapReady($event)">
    </div>
    <div class="panel samim">
        <label class="floors">
            {{ 'FLOORS' | translate }}
            <input type="number" min="1" max="60" [(ngModel)]="floors" (ngModelChange)="onFloorsChange()">
        </label>
        <div *ngIf="coverage" class="legend">
            {{ 'WIRELESS_SCORE' | translate }}
            <span class="band" *ngFor="let band of coverage.bands" [style.background]="band.color"
                [class.dark]="band.dark">{{ band.score }}</span>
            <div class="note">{{ 'WIRELESS_LEGEND_NOTE' | translate:{ floors: coverage.floors } }} ({{ coverage.date | date:'yyyy-MM-dd' }})</div>
        </div>
        <div *ngIf="error" class="verdict none">{{ error }}</div>
        <ng-container *ngIf="result && !error">
            <div class="verdict" [ngClass]="result.level">
                <b>{{ result.score }}٪</b> {{ result.text }}
            </div>
            <table *ngIf="result.towers?.length">
                <thead>
                    <tr>
                        <th>{{ 'POP_SITE' | translate }}</th>
                        <th>{{ 'WIRELESS_DISTANCE' | translate }}</th>
                        <th>{{ 'WIRELESS_MARGIN' | translate }}</th>
                        <th>{{ 'WIRELESS_SCORE' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let tower of result.towers" [class.best]="tower.code === result.best">
                        <td>{{ tower.name }} ({{ tower.code }})</td>
                        <td>{{ tower.dist }}</td>
                        <td>{{ tower.margin }}</td>
                        <td>{{ tower.score }}</td>
                    </tr>
                </tbody>
            </table>
            <button class="btn btn-sm btn-primary" (click)="createIssue()">
                {{ (!staff ? 'ISSUE_CREATE' : result.feasible ? 'ISSUE_CREATE_LEAD' : 'ISSUE_CREATE_INQUIRY') | translate }}
            </button>
        </ng-container>
    </div>
</div>
